import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ChartItem } from 'chart.js';
import { ChoroplethChart, topojson } from 'chartjs-chart-geo';
import { Topology } from 'topojson-specification';
import { Observable } from 'rxjs';
import { SimpleMatTooltipComponent } from '../../../../simple-mat-tooltip';
import { MapChartBaseComponent } from '../map-chart-base.component';
import { mapAxisLabelEventPlugin } from '../plugins';
import { Feature } from 'geojson';
import { GEOMETRY_ID_STATE_CODE_MAP, MAP_DEVICE_PIXEL_RATIO } from '../../../configs';
import { defaultOnLabelMouseMove } from '../../../plugins';

@Component({
    selector: 'app-states-map-chart',
    templateUrl: './states-map-chart.component.html',
    styleUrls: ['./states-map-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatesMapChartComponent extends MapChartBaseComponent {


  protected getTopology(): Observable<Topology> {
    return this.geoChartJsonService.getStatesObject();
  }

  protected createChart(context: ChartItem, data: number[], labels: string[], postfix: string, topology: Topology): ChoroplethChart {
    const nation: any[] = topojson.feature(topology, topology.objects.nation)['features'][0];
    const states: Array<Feature> = topojson.feature(topology, topology.objects.states)['features'];
    const tooltip: SimpleMatTooltipComponent = this.tooltip();

    return new ChoroplethChart(context, {
      plugins: [
        mapAxisLabelEventPlugin
      ],
      data: {
        labels: states.map((feature) => feature.properties.name),
        datasets: [{
          label: 'States',
          outline: nation,
          data: states.map((feature) => {
            const abbr: string = GEOMETRY_ID_STATE_CODE_MAP[feature.id];
            const index: number = labels.findIndex((label: string) => label === abbr);
            return {
              feature,
              value: index > -1 ? data[index] : 0,
            };
          }),
        }]
      },
      options: {
        devicePixelRatio: MAP_DEVICE_PIXEL_RATIO,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          [mapAxisLabelEventPlugin.id]: {
            postfix: postfix,
            onLabelMouseMove: defaultOnLabelMouseMove(tooltip)
          },
          tooltip:  { enabled: false },
          legend: { display: false },
          datalabels: { display: false }
        },
        scales: {
          color: {
            axis: 'x',
            quantize: this.calcMaxAvailableColors(data),
            legend: {
              position: 'bottom-right',
              align: 'bottom'
            },
          }
        },
      },
    });
  }
}
